import getInfoItinerary from './getInfoItinerary';
import getInfoLandTour from './getInfoLandTour';
import { POST_TOUR } from './Constants';
const getResumeItinerary = itinerary => {
  const { days, preTour, postTour, ship, ports } = itinerary || {};

  const { debark, embark, dailyPorts, filteredPorts } = getInfoItinerary(
    days,
    ports,
  );
  const { landTours: preLandTours } = getInfoLandTour(preTour?.days);
  const { landTours: postLandTours } = getInfoLandTour(
    postTour?.days,
    POST_TOUR,
  );
  const landTours = [...preLandTours, ...postLandTours];
  const isRoundtrip =
    embark?.name === debark?.name && embark?.region === debark?.region;

  return {
    debark,
    embark,
    dailyPorts,
    filteredPorts,
    landTours,
    onboard: ship?.name,
    isRoundtrip,
  };
};
export default getResumeItinerary;
